import * as React from 'react';
import { IBasePageProps } from '../../configuration/IConfiguration';
import UserProfile, { IUserProfileFormItem } from '../../../Users/UserProfile';
import * as UserActionCreators from "../../../../actions/user.actions";
import * as LoginActionCreators from "../../../../actions/login.actions";
import ContentContainer from '../../../Content/ContentContainer';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../app';
import LeaveProgram from '../../../Users/LeaveProgram';

interface IPageUserProfileProps {
    formItems: IUserProfileFormItem[];

    updatingUser: boolean;

    emailOptOut: typeof UserActionCreators.emailOptOutRequest;
    login: typeof LoginActionCreators.login;
    logout: typeof LoginActionCreators.logout;
    updateUser: typeof UserActionCreators.updateUser;
}

interface IPageUserProfileRouteParams {
}

interface IPageUserProfileQueryParams {
}

type PageUserProfileProps = IBasePageProps<IPageUserProfileRouteParams, IPageUserProfileQueryParams> & IPageUserProfileProps;

class PageUserProfile extends React.Component<PageUserProfileProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (<div className="m-md-4 m-2">
            <div className="col-12 border-bottom my-2 pb-2">
                <h2 className="m-0">User Profile</h2>
            </div>
            {this.props.currentUser ?
                <>
                    <UserProfile
                        className="col-lg-6 col-12"
                        user={this.props.currentUser}
                        loginActive={this.props.currentUser !== undefined}
                        formItems={this.props.formItems}
                        formItemClassName={"col-md-9"}
                        formItemLabelClassName={"lead col-md-3"}
                        login={this.props.login}
                        logout={this.props.logout}
                        updateUser={this.props.updateUser}
                        saving={this.props.updatingUser}
                    />
                    <LeaveProgram
                        className={"col-lg-6 col-12 mt-4"}
                        user={this.props.currentUser}
                        emailOptOut={this.props.emailOptOut}
                    />
                </> : undefined
            }
        </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageUserProfileProps): any => {

    return {
        updatingUser: state.user.updatingAccount,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        emailOptOut: UserActionCreators.emailOptOutRequest,
        login: LoginActionCreators.login,
        logout: LoginActionCreators.logout,
        updateUser: UserActionCreators.updateUser,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageUserProfile);